import { ReactNode } from "react";
import PublicNavbar from "./PublicNavbar";
import PublicFooter from "./PublicFooter";
import MobileTabBar from "./MobileTabBar";
import { InteractiveBackground } from "./InteractiveBackground";
import CustomCursor from "./home/CustomCursor";
import { useLanguage } from "@/contexts/LanguageContext";
import { SimpleChatProvider } from "@/contexts/SimpleChatContext";
import { usePrerenderReady } from "@/lib/prerenderReady";

interface PublicLayoutProps {
    children: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
    const { dir } = useLanguage();
    usePrerenderReady();

    return (
        <SimpleChatProvider>
            <div className="min-h-[100svh] flex flex-col relative selection:bg-primary/20 bg-background" dir={dir}>
                <InteractiveBackground />

                <div className="relative z-10 flex flex-col min-h-[100svh]">
                    <PublicNavbar />
                    <main className="flex-grow pb-[calc(4rem+env(safe-area-inset-bottom))] lg:pb-0">
                        {children}
                    </main>
                    <PublicFooter />
                </div>

                {/* Mobile bottom tab bar — primary nav on phones, replaces top hamburger */}
                <MobileTabBar />

                {/* v2 custom cursor — desktop only, respects prefers-reduced-motion */}
                <CustomCursor />
            </div>
        </SimpleChatProvider>
    );
};

export default PublicLayout;
